/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import makeUrlSearchParams from './makeUrlSearchParams';

export default function makeUrl(baseUrl, path, options = {}) {
  return baseUrl + path + makeUrlSearchParams(options.urlSearchParams);
}
